import React from 'react';
import HumanResourcesHeader from 'routes/HumanResourcesModule/HumanResourcesHome/HumanResourcesHeader';
import StyHome from 'routes/HumanResourcesModule/components/ui/StyHome';
import StyHrPageContainer from 'routes/HumanResourcesModule/components/ui/StyHrPageContainer';
import { useTranslation } from 'react-i18next';

type Props = {
    title: string;
    children?: React.ReactNode;
};

export const HrPage = ({ title, children = undefined }: Props) => {
    const { t } = useTranslation();
    return (
        <StyHrPageContainer className="page-container dx-viewport">
            <HumanResourcesHeader title={t(title)} />
            <StyHome>{children}</StyHome>
        </StyHrPageContainer>
    );
};
